import { render } from "./user_component.html?vue&type=template&id=04ea8a7d&external"
import script from "./user_component.js?vue&type=script&lang=js&external"
export * from "./user_component.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__